export const ASSESSMENT_IDENTITY_KEY = "gap-assessment-public-identity-v1";
export const ASSESSMENT_SUBMISSION_KEY = "gap-assessment-active-submission-v1";

export function readAssessmentStorage(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || "null");
  } catch (_) {
    return null;
  }
}
